// Auto-generated from container.spec.js
export default {
  "tagName": "ui-container"
};
